import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LazyMotion, domAnimation } from "framer-motion";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";
import { CookieConsent } from "@/components/site/CookieConsent";

const ServicePage = lazy(() => import("@/pages/ServicePage"));
const CoveragePage = lazy(() => import("@/pages/CoveragePage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const LocationPage = lazy(() => import("@/pages/LocationPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));

const Fallback = () => <div className="min-h-screen bg-void" aria-hidden="true" />;

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" theme="light" richColors />
      <CookieConsent />
      <LazyMotion features={domAnimation}>
        <BrowserRouter>
          <Suspense fallback={<Fallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/rewires" element={<ServicePage id="rewires" />} />
              <Route path="/cctv-installation" element={<ServicePage id="cctv" />} />
              <Route path="/fire-alarm-installation" element={<ServicePage id="fire-alarms" />} />
              <Route path="/electrical-fault-finding" element={<ServicePage id="fault-finding" />} />
              <Route path="/emergency-electrician" element={<ServicePage id="emergency" />} />
              <Route path="/areas-we-cover" element={<CoveragePage />} />
              <Route path="/electrician-bradford" element={<LocationPage id="bradford" />} />
              <Route path="/electrician-leeds" element={<LocationPage id="leeds" />} />
              <Route path="/electrician-huddersfield" element={<LocationPage id="huddersfield" />} />
              <Route path="/electrician-halifax" element={<LocationPage id="halifax" />} />
              <Route path="/electrician-wakefield" element={<LocationPage id="wakefield" />} />
              <Route path="/electrician-keighley" element={<LocationPage id="keighley" />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </LazyMotion>
    </div>
  );
}

export default App;
